// PolitiqueConfidencialite.jsx
import React from "react";
import "./privacy-policy.css"; // reuse the same CSS as the English page
import Navbar from "./Navbar";

const PolitiqueConfidencialite = () => {
  return (
    <>
      <Navbar />
      <main className="policy">
        <div className="policy__inner">
          <header className="policy__header">
            <h1 className="policy__title">Politique de confidentialité</h1>
            <p className="policy__updated">
              Dernière mise à jour : <strong>1er septembre 2025</strong>
            </p>
          </header>

          <p className="policy__lead">
            Chez <span className="accent">FlxDeck</span>, la protection de votre vie privée est notre priorité. La présente politique de confidentialité explique comment nous recueillons, utilisons,
            divulguons et protégeons vos renseignements personnels conformément à la Loi sur la protection des renseignements personnels dans le secteur privé du Québec et à la <em>LPRPDE</em> (Loi
            sur la protection des renseignements personnels et les documents électroniques) du Canada. En utilisant nos services, vous acceptez les pratiques décrites dans la présente politique.
          </p>

          <section className="policy__section">
            <h2>1. Les informations que nous collectons</h2>
            <p>Nous collectons et traitons des informations personnelles pour fournir, améliorer et sécuriser nos services.</p>

            <h3>1.1 Informations personnelles</h3>
            <p>Nous pouvons collecter :</p>
            <ul>
              <li>Le nom, l'adresse électronique, le numéro de téléphone et l'adresse du domicile ou de l'entreprise.</li>
              <li>Les détails du paiement lorsque vous achetez nos services.</li>
              <li>Les informations fournies volontairement lors de demandes de renseignements, de consultations ou de prestations de services.</li>
            </ul>

            <h3>1.2 Informations sensibles</h3>
            <p>
              Les données sensibles (par exemple, les mots de passe, les détails de sécurité) ne sont collectées qu'avec votre consentement explicite pour des services spécifiques, tels que les
              services de test de pénétration.
            </p>

            <h3>1.3 Fichiers journaux</h3>
            <p>
              https://www.flxdeck.com suit une procédure standard d'utilisation de fichiers journaux. Ces fichiers enregistrent les visiteurs lorsqu'ils visitent les sites web. Les informations
              collectées par les fichiers journaux comprennent les adresses IP (Internet Protocol), le type de navigateur, le fournisseur d'accès à Internet (FAI), la date et l'heure, les pages de
              renvoi et de sortie et éventuellement le nombre de clics. Ces données ne sont pas liées à des informations personnellement identifiables. L'objectif de ces informations est d'analyser
              les tendances, d'administrer le site, de suivre les mouvements des utilisateurs sur le site et de recueillir des informations démographiques.
            </p>
          </section>

          <section className="policy__section">
            <h2>2. Comment nous utilisons vos informations</h2>
            <ul>
              <li>Fournir et personnaliser nos services, y compris les solutions de surveillance et de sécurité.</li>
              <li>Pour communiquer avec vous au sujet des mises à jour, des promotions et des améliorations de service.</li>
              <li>Respecter les obligations légales et assurer la conformité réglementaire.</li>
              <li>Analyser et améliorer les performances de notre site web et de nos services.</li>
              <li>Pour facturer nos services et gérer les recouvrements.</li>
            </ul>
          </section>

          <section className="policy__section">
            <h2>3. Partage des informations</h2>
            <p>Vos informations sont traitées de manière responsable et ne sont partagées qu'en cas de nécessité :</p>
            <ul>
              <li>
                <strong>Fournisseurs de services :</strong> Des tiers de confiance qui nous aident à fournir nos services (par exemple, des sociétés de traitement des paiements).
              </li>
              <li>
                <strong>Obligations légales :</strong> Lorsque la loi l'exige, par exemple en cas d'ordonnance d'un tribunal ou de réglementation gouvernementale.
              </li>
              <li>
                <strong>Partenaires marketing :</strong> Uniquement avec votre consentement explicite à des fins promotionnelles.
              </li>
            </ul>
            <p>Nous veillons à ce que tous les tiers respectent des normes strictes en matière de confidentialité et de protection des données.</p>
          </section>

          <section className="policy__section">
            <h2>4. Vos droits</h2>
            <p>Vous disposez des droits suivants concernant vos informations personnelles :</p>
            <ul>
              <li>
                <strong>Accès :</strong> Demander une copie de vos informations personnelles.
              </li>
              <li>
                <strong>Correction :</strong> Mettre à jour toute inexactitude dans vos données.
              </li>
              <li>
                <strong>Suppression :</strong> Demander la suppression de vos données, le cas échéant.
              </li>
              <li>
                <strong>Gestion du consentement :</strong> Retirez à tout moment votre consentement au traitement des données.
              </li>
              <li>
                <strong>Portabilité des données :</strong> Demander le transfert de vos données dans un format structuré et lisible par machine.
              </li>
            </ul>

            <div className="policy__card">
              <p className="policy__card-title">Pour exercer vos droits, contactez notre responsable de la protection de la vie privée à :</p>
              <p>
                <strong>Christian El-Hamaoui</strong>
                <br />
                Responsable de la protection des renseignements personnels
                <br />
                <a href="mailto:contact@flxdeck.com">contact@flxdeck.com</a>
              </p>
            </div>
          </section>

          <section className="policy__section">
            <h2>5. Sécurité des données</h2>
            <p>
              Nous mettons en œuvre une gamme complète de mesures de sécurité pour garantir la protection et l'exactitude des informations personnelles que nous conservons contre toute utilisation ou
              modification non autorisée. Ces mesures sont les suivantes :
            </p>
            <ul>
              <li>La désignation d'un responsable de la protection de la vie privée</li>
              <li>La mise en place de contrôles administratifs</li>
              <li>La mise en place de mesures de sécurité physique</li>
              <li>Sensibiliser et former le personnel</li>
              <li>L'utilisation de dispositifs de sécurité technologiques</li>
            </ul>
            <p>
              Malgré les précautions prises lors de la collecte de vos données personnelles, il est important de noter que la transmission de données sur Internet, y compris par courrier électronique,
              n'est jamais totalement sécurisée. Nous mettons tout en œuvre pour protéger les informations personnelles, mais nous ne pouvons pas garantir la sécurité des données que nous recevons ou
              transmettons.
            </p>
          </section>

          <section className="policy__section">
            <h2>6. Conservation des données</h2>
            <p>Nous ne conservons vos informations personnelles que le temps nécessaire pour :</p>
            <ul>
              <li>Remplir les objectifs pour lesquels elles ont été collectées.</li>
              <li>Respecter les exigences légales, fiscales ou réglementaires.</li>
              <li>Résoudre les litiges et appliquer les accords.</li>
            </ul>
            <p>Une fois que la conservation n'est plus nécessaire, vos données sont supprimées en toute sécurité ou rendues anonymes.</p>
          </section>

          <section className="policy__section">
            <h2>7. Cookies et suivi</h2>
            <p>
              Nous ne collectons ni n'utilisons de cookies sur notre site web. Nous accordons la priorité à votre vie privée et ne suivons pas vos activités de navigation à des fins de publicité ou de
              marketing. Nous nous engageons à offrir à nos utilisateurs une expérience de navigation sécurisée et privée. Veuillez noter que, bien que nous n'utilisions pas de cookies, certains
              services ou applications de tiers intégrés à notre site web peuvent utiliser des cookies, et leur utilisation est soumise aux politiques de confidentialité des tiers respectifs.
            </p>
          </section>

          <section className="policy__section">
            <h2>8. Transferts de données transfrontaliers</h2>
            <p>
              Vos données peuvent être stockées ou traitées en dehors du Canada (par exemple, aux États-Unis ou en Europe) par nos fournisseurs de services. Dans ce cas, nous veillons au respect des
              lois applicables en matière de protection de la vie privée et des mesures adéquates de protection des données.
            </p>
          </section>

          <section className="policy__section">
            <h2>9. Mises à jour de la présente politique</h2>
            <p>
              Nous pouvons mettre à jour la présente politique de confidentialité périodiquement pour refléter les changements dans nos pratiques ou nos obligations légales. Les modifications
              importantes seront communiquées par courrier électronique ou par un avis sur notre site web.
            </p>
          </section>

          <section className="policy__section">
            <h2>10. Contact</h2>
            <p>
              Pour toute question, préoccupation ou demande relative à la présente politique de confidentialité, veuillez contacter notre responsable de la protection de la vie privée à l'adresse{" "}
              <a href="mailto:contact@flxdeck.com">contact@flxdeck.com</a>.
            </p>
          </section>
        </div>
      </main>
    </>
  );
};

export default PolitiqueConfidencialite;
